/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

/**
 * What is being uploaded. Decides the key prefix, the accepted content types and the size limit — the client never names a path.
 */
export type PresignUploadDtoScope = typeof PresignUploadDtoScope[keyof typeof PresignUploadDtoScope];


export const PresignUploadDtoScope = {
  'player-photo': 'player-photo',
  'player-document': 'player-document',
  'contract-document': 'contract-document',
  'task-attachment': 'task-attachment',
} as const;
